import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { manageEventListener } from '../../../common/utils';

const InteractiveSelectListItem = props => {
  const {
    key,
    setOptionTitle,
    onKeyUp,
    onSelect,
    index,
    value,
    label
  } = props;

  const refListItem = useRef();

  const listItemAttributes = {
    key,
    title: setOptionTitle({ label, value }),
    tabIndex: -1,
    ref: refListItem,
    'data-index': index,
    'data-value': value
  };

  const handleClick = () => onSelect(value);
  const handleKeyUp = ({ key: keyName }) => onKeyUp(keyName, index, value);
  const handleKeyDown = event => event.preventDefault();

  useEffect(() => {
    const { current: listItemElement } = refListItem;

    const eventHandlers = [
      { eventName: 'click', eventHandler: handleClick },
      { eventName: 'keyup', eventHandler: handleKeyUp },
      { eventName: 'keydown', eventHandler: handleKeyDown }
    ];

    eventHandlers.forEach(({ eventName, eventHandler }) => {
      manageEventListener(listItemElement, eventName, 'add', eventHandler);
    });

    // Returned function will be called on component unmount:
    return () => {
      eventHandlers.forEach(({ eventName, eventHandler }) => {
        manageEventListener(listItemElement, eventName, 'remove', eventHandler);
      });
    };
  }, []);

  return <li {...listItemAttributes}>{label}</li>;
};

InteractiveSelectListItem.propTypes = {
  key: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  onKeyUp: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  setOptionTitle: PropTypes.func.isRequired,
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]).isRequired
};

export default InteractiveSelectListItem;